export const campaignConst = {
  FETCH_CAMPAIGN_BEGIN: 'FETCH_CAMPAIGN_BEGIN',
  FETCH_CAMPAIGN_SUCCESS: 'FETCH_CAMPAIGN_SUCCESS',
  FETCH_CAMPAIGN_FAILED: 'FETCH_CAMPAIGN_FAILED',
  ADD_NEW_CAMPAIGN_TO_PROMOTION_BEGIN: 'ADD_NEW_CAMPAIGN_TO_PROMOTION_BEGIN',
  ADD_NEW_CAMPAIGN_TO_PROMOTION_SUCCESS:
    'ADD_NEW_CAMPAIGN_TO_PROMOTION_SUCCESS',
  ADD_NEW_CAMPAIGN_TO_PROMOTION_FAILED: 'ADD_NEW_CAMPAIGN_TO_PROMOTION_FAILED',
};
